import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Table } from 'antd'

import getReimbursementsBalances, {
  PagedReimbursementsBalances,
} from 'core/application/adminDashboard/reimbursements/perks/reimbursementsBalances/getReimbursementsBalances'
import OrderedPageFilter from 'core/application/commons/orderedPageFilter'

import { Skeleton } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import { reimbursementsBalancesColumns } from './ReimbursementsBalancesColumns'
import BalanceDetails from './balanceDetails'

const pagedColumnDefaultValues = {
  items: [],
  pageCount: 1,
  pageNumber: 1,
  pageSize: 10,
  totalItemCount: 0,
}

const defaultFilter = {
  pageNumber: 1,
  pageSize: 10,
  orderColumn: 'fullName',
  orderDescending: false,
}

interface ReimbursementsBalancesProps {
  planPeriodId: string
}

const ReimbursementsBalances: React.FC<ReimbursementsBalancesProps> = ({ planPeriodId }) => {
  const [reimbursementsBalancesFilter, setReimbursementsBalancesFilter] = useState<OrderedPageFilter>(defaultFilter)
  const { t: translate } = useTranslation()

  const {
    data: reimbursementsBalances,
    isLoading: isReimbursementsBalancesQueryLoading,
    reload: reloadReimbursementsBalancesQuery,
  } = useQueryRequestV2<PagedReimbursementsBalances>({
    initialState: pagedColumnDefaultValues,
    queryFn: () => getReimbursementsBalances(reimbursementsBalancesFilter, planPeriodId),
  })
  useEffect(() => {
    reloadReimbursementsBalancesQuery()
  }, [planPeriodId, reimbursementsBalancesFilter])

  const onReimbursementsBalancesTableChange = (pagination: any, filters: any, sorter: any) => {
    setReimbursementsBalancesFilter({
      ...reimbursementsBalancesFilter,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
      orderColumn: 'fullName',
      orderDescending: sorter.order !== 'ascend',
    })
  }

  return (
    <div className="mt-24">
      <Skeleton active loading={isReimbursementsBalancesQueryLoading}>
        {reimbursementsBalances && (
          <Table
            dataSource={reimbursementsBalances.items}
            onChange={onReimbursementsBalancesTableChange}
            rowKey={(record) => `${record.companyUserId}-${record.categoryName}`}
            //loading={isReimbursementsBalancesQueryLoading}
            scroll={{ x: 1000 }}
            columns={reimbursementsBalancesColumns(translate, reimbursementsBalancesFilter)}
            tableLayout="fixed"
            pagination={{
              total: reimbursementsBalances.totalItemCount,
              pageSize: reimbursementsBalances.pageSize,
              current: reimbursementsBalances.pageNumber,
            }}
            expandedRowRender={(balance) => {
              return (
                <BalanceDetails
                  companyUserId={balance.companyUserId}
                  planPeriodId={planPeriodId}
                  categoryId={balance.categoryId}
                />
              )
            }}
          />
        )}
      </Skeleton>
    </div>
  )
}

export default ReimbursementsBalances
